import React from 'react';
import Page from '../components/Page';
import ComingSoonMsg from '../components/ComingSoon';

class PosPage extends React.Component {
  render() {
    return (
      <Page
        className="page"
        title="POS"
        breadcrumbs={[{ name: 'POS', active: true }]}
      >
        <ComingSoonMsg />
      </Page>
    );
  }
}
export default PosPage;
